import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const SchoolIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M15.786 4.712c-.588-.192-1.176-.043-1.764.106-.632.16-1.264.32-1.896.057a.2.2 0 0 1-.091-.075.214.214 0 0 1-.035-.116V2.502a.214.214 0 0 1 .08-.166.194.194 0 0 1 .175-.033c.588.192 1.176.043 1.765-.106.631-.16 1.263-.32 1.895-.057a.2.2 0 0 1 .09.075.214.214 0 0 1 .035.116v2.182a.214.214 0 0 1-.079.166.194.194 0 0 1-.175.033Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M17.952 9.924 12 5.934 6.04 9.93V22h11.912V9.924Zm-6.558 3.885H8.97v-1.507h2.424v1.507Zm1.212 0h2.424v-1.507h-2.424v1.507ZM8.97 16.824h2.424v-1.507H8.97v1.507Zm3.636 0h2.424v-1.507h-2.424v1.507Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M4.522 12.15H2V22h2.522v-9.85ZM19.47 22H22v-9.85h-2.53V22Z"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M14.022 4.818c.588-.149 1.176-.298 1.764-.106a.19.19 0 0 0 .175-.033.214.214 0 0 0 .08-.166V2.331a.214.214 0 0 0-.035-.116.2.2 0 0 0-.091-.075c-.632-.263-1.264-.103-1.895.057-.589.15-1.177.298-1.765.106a.19.19 0 0 0-.176.033.214.214 0 0 0-.08.166v2.182c.001.041.013.081.036.116a.2.2 0 0 0 .09.075c.633.263 1.265.103 1.896-.057ZM8.97 13.81h2.424v-1.508H8.97v1.507ZM15.03 13.81h-2.424v-1.508h2.424v1.507ZM8.97 16.824h2.424v-1.507H8.97v1.507ZM15.03 16.824h-2.424v-1.507h2.424v1.507Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M17.96 9.93 12 5.933 6.04 9.93v2.222H2V22h20v-9.85h-4.04V9.93ZM7.859 20.19v-9.3L12 8.117l4.141 2.776v9.299H7.86Zm-4.04-6.231H6.04v6.231H3.818V13.96Zm14.14 0v6.231h2.223V13.96H17.96Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `SchoolIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { SchoolIcon };
//# sourceMappingURL=SchoolIcon.mjs.map
